import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Percent, Scissors, Tags, Landmark, ChevronDown, ChevronRight, Banknote, ShieldCheck, TrendingDown } from "lucide-react";
import KdvRates from "./KdvRates";
import TevkifatRates from "./TevkifatRates";
import ExpenseCategories from "./ExpenseCategories";
import Banks from "./Banks";
import WageRates from "./WageRates";
import SgkRates from "./SgkRates";
import DepreciationCodes from "./DepreciationCodes";
import Holidays from "./Holidays";
import TaxBrackets from "./TaxBrackets";
import { CalendarOff, Receipt } from "lucide-react";

const SECTIONS = [
  { key: "kdv", label: "KDV Oran Tanımları", desc: "Faturalarda kullanılacak KDV oranlarını tanımlayın", icon: Percent, node: <KdvRates /> },
  { key: "tevkifat", label: "KDV Tevkifat Tanımları", desc: "Faturalarda kullanılacak KDV tevkifat oranlarını tanımlayın", icon: Scissors, node: <TevkifatRates /> },
  { key: "ucretler", label: "Ücretler", desc: "Asgari ücret (brüt/net), yemek, yol vb. ücret tanımları ve geçerlilik tarihleri", icon: Banknote, node: <WageRates /> },
  { key: "sgk", label: "SGK Prim Oranları", desc: "İşçi / işveren / devlet payı sigorta kolu prim oranları ve geçerlilik tarihleri", icon: ShieldCheck, node: <SgkRates /> },
  { key: "vergi", label: "Gelir Vergisi Dilimleri", desc: "Yıl bazlı ücret gelir vergisi tarifesi, asgari ücret brütü, damga vergisi oranı ve SGK tavan katsayısı — Bordro hesabının kaynağı", icon: Receipt, node: <TaxBrackets /> },
  { key: "amortisman", label: "Amortisman Kodları", desc: "VUK amortisman oranları tablosu (333/365/389/418 nolu tebliğler) — kod, faydalı ömür ve normal amortisman oranı", icon: TrendingDown, node: <DepreciationCodes /> },
  { key: "tatiller", label: "Resmi Tatiller", desc: "Geçici personel gün hesabında düşülen resmi ve dini bayram günleri — dini bayramları her yıl tarihiyle girin", icon: CalendarOff, node: <Holidays /> },
  { key: "kategori", label: "Kategori (Gider Kalemi)", desc: "Gelir/gider faturalarında kullanılacak kategori tanımları", icon: Tags, node: <ExpenseCategories /> },
  { key: "bankalar", label: "Bankalar", desc: "Çek ve banka kredilerinde kullanılacak banka/şube/hesap tanımları", icon: Landmark, node: <Banks /> },
];

export default function SabitTanimlar() {
  const [params, setParams] = useSearchParams();
  const [open, setOpen] = useState(params.get("bolum") || "");
  const toggle = (k) => {
    const v = open === k ? "" : k;
    setOpen(v);
    setParams(v ? { bolum: v } : {}, { replace: true });
  };

  return (
    <div className="space-y-4" data-testid="page-sabit-tanimlar">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Sabit Tanımlar</h1>
        <p className="text-sm text-slate-500 mt-1">Tanımlamak istediğiniz bölümün butonuna basın — ilgili tanım ekranı aşağıda açılır.</p>
      </div>
      {SECTIONS.map((s) => {
        const Icon = s.icon;
        const isOpen = open === s.key;
        return (
          <div key={s.key} className={`bg-white border rounded-lg overflow-hidden transition-colors ${isOpen ? "border-amber-400 shadow-sm" : "border-slate-200"}`} data-testid={`sabit-sec-${s.key}`}>
            <button onClick={() => toggle(s.key)} data-testid={`sabit-btn-${s.key}`}
              className="w-full flex items-center gap-3 px-4 py-3.5 text-left hover:bg-slate-50 transition-colors">
              <span className={`p-2 rounded-md ${isOpen ? "bg-amber-100 text-amber-700" : "bg-slate-100 text-slate-500"}`}><Icon className="w-4 h-4" /></span>
              <span className="flex-1">
                <span className="block text-sm font-bold text-slate-900">{s.label}</span>
                <span className="block text-xs text-slate-500">{s.desc}</span>
              </span>
              {isOpen ? <ChevronDown className="w-4 h-4 text-amber-600" /> : <ChevronRight className="w-4 h-4 text-slate-400" />}
            </button>
            {isOpen && (
              <div className="border-t border-amber-200 px-4 py-4" data-testid={`sabit-panel-${s.key}`}>
                {s.node}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
